import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SocketProvider } from '../../providers/socket/socket';
import { SceneProvider } from '../../providers/scene/scene';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'page-judge',
  templateUrl: 'judge.html',
  providers: [SceneProvider, HttpClient]
})
export class JudgePage {
  player1image;
  player2image;
  player1name;
  player2name;
  sceneKey;
  sceneData;
  loaded = false;
  image1data = {};
  image2data = {};
  isJudge;
  background;

  constructor(
    public navCtrl: NavController, 
    private socketProvider: SocketProvider, 
    private navParams: NavParams, 
    private sceneProvider: SceneProvider
    ) {
      
    this.player1image = this.navParams.get('image1');
    this.player2image = this.navParams.get('image2');
    this.player1name = this.navParams.get('player1');
    this.player2name = this.navParams.get('player2');
    this.isJudge = this.navParams.get('isJudge');
    this.sceneKey = this.navParams.get('scene');
    this.sceneProvider.getImageData(this.sceneKey).subscribe((data) => {
      this.sceneData = data;
      console.log('sceneData', data);
      this.loaded = true;
      this.image1data = data[0].faceRectangle;
      this.image2data = data[1].faceRectangle;
    });
    this.background = '../../assets/imgs/background/' + this.socketProvider.getRandomBackground();
  }

  vote(option) {
    this.socketProvider.sendMessage({
      action: 'judge',
      vote: option
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/judge/judge.ts